import { connect } from "react-redux";
import { RootState } from "store/store";
import ConfigurationLayout from "./ConfigurationLayout";
import {
    setIsDeleteFetched,
    setTenantDeleteWorkflow,
} from "store/environments/tenants/tenant-delete/tenant-delete-actions";
import {
    getActiveEnvironmentMoniker,
    getIsActiveEnvironmentSet,
} from "store/environments/environment-selectors";
import { getActiveTenantMoniker } from "store/environments/tenants/tenants-selectors";
import { setErrorTenantDeleteMessage } from "store/common/initialization/initialization-actions";
import {
    getActiveTenantDeleteWorkflow,
    getIsDeleteFetched,
} from "store/environments/tenants/tenant-delete/tenant-delete-selectors";
import { getErrorResponseMessage } from "store/common/initialization/initialization-selectors";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
        tenantMoniker: getActiveTenantMoniker(state),
        activeTenant: state.tenantsReducer.activeTenant,
        activeTenantDeleteWorkflow: getActiveTenantDeleteWorkflow(state),
        isActiveEnvironmentSet: getIsActiveEnvironmentSet(state),
        isDeleteFetched: getIsDeleteFetched(state),
        errorMessage: getErrorResponseMessage(state),
    };
};
const ConfigurationLayoutContainer = connect(mapStateToProps, {
    setTenantDeleteWorkflow,
    setErrorTenantDeleteMessage,
    setIsDeleteFetched,
})(ConfigurationLayout);

export default ConfigurationLayoutContainer;
